import { createTheme } from '@mui/material/styles';

const SEV_COLORS = {
  s0: '#9ca3af',
  s1: '#2563eb',
  s2: '#d97706',
  s3: '#dc2626',
  s4: '#7c2d12',
  srcInsights: '#0ea5e9',
  srcFile: '#10b981',
  srcDb: '#a855f7',
};

declare module '@mui/material/styles' {
  interface Palette { sev: typeof SEV_COLORS; }
  interface PaletteOptions { sev?: typeof SEV_COLORS; }
}

export const theme = createTheme({
  palette: {
    mode: window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light',
    primary: { main: '#2563eb' },
    sev: SEV_COLORS,
  },
  shape: { borderRadius: 8 },
  typography: {
    fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
  },
});

export const sevName = (s: number) => ['TRACE', 'INFO', 'WARN', 'ERROR', 'CRIT'][s] ?? 'TRACE';
export const sevColor = (s: number) =>
  ([SEV_COLORS.s0, SEV_COLORS.s1, SEV_COLORS.s2, SEV_COLORS.s3, SEV_COLORS.s4][s] ?? SEV_COLORS.s0);
export const srcColor = (s: 'insights' | 'file' | 'db') =>
  ({ insights: SEV_COLORS.srcInsights, file: SEV_COLORS.srcFile, db: SEV_COLORS.srcDb }[s]);
